import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import TitleCard from 'components/TitleCard';
import { DefaultFormFieldLayout } from 'components/FormField';
import { ShareableLinkField, ShareNowField } from 'components/FormFields';
import NudgesOverviewCard from 'components/NudgesOverviewCard';
import FormStack from 'components/FormStack';
function AssetSharePage(_ref) {
  var id = _ref.id,
    playlistId = _ref.playlistId,
    shareData = _ref.shareData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, shareData && /*#__PURE__*/React.createElement(TitleCard, {
    title: t('actions_share_now'),
    variant: "raised"
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(ShareNowField, {
    shareData: shareData
  }), /*#__PURE__*/React.createElement(ShareableLinkField, {
    contentId: id,
    parentPlaylistId: playlistId
  })))), /*#__PURE__*/React.createElement(NudgesOverviewCard, {
    contentId: id,
    type: "asset",
    variant: "raised"
  }));
}
export default AssetSharePage;